// @flow
import React from 'react';
import Modal from 'Components/Modal';
import DealerModel from 'Stores/DealerModel';
import styles from './styles.scss';
import { Col, Row } from '../../components/Grid';
import Button from '../../components/Button';
import { gaPush } from 'Utils/ga_push';
import { withRouter } from 'react-router-dom';

type State = {
  errors: { [string]: ?string },
  dealer: string,
  loading: boolean,
};

type Props = {
  dealer: DealerModel,
  isOpen: () => void,
  onClose: () => void,
  history: Object,
};

class ConfiguratorModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      modalOpened: false,
    };
  }

  componentDidUpdate(_, prevState) {
    const { modalOpened } = this.state;

    if (modalOpened !== prevState.modalOpened && modalOpened) {
      gaPush({
        event: 'gaEvent',
        category: 'modalOpen',
        action: 'modal click',
        label: 'true',
      });
    }
  }

  closeAction = () => {
    const { onClose, history } = this.props;

    history.push('/');

    if (onClose) {
      gaPush({
        event: 'gaEvent',
        category: 'modalOpen',
        action: 'modal click',
        label: 'false',
      });
      onClose();
    }
  };

  render() {
    const { isOpen, dealer } = this.props;
    const link = 'https://www.mazda.de/konfigurator/?dealerid='.concat(
      dealer.id,
      '&utm_source=mazdahws&utm_medium=referral&utm_campaign=MMDKONFIGURATORHWS&utm_term=',
      dealer.id,
      '&utm_content=hws-configurator&campaignCode=MMD_KONFIGURATOR_HWS'
    );

    return (
      <Modal
        isOpen={isOpen}
        onClose={this.closeAction}
        className={styles.contactmodal}
        onOpened={() => {
          this.setState({ modalOpened: true });
        }}
      >
        <Row>
          <Col cols={12}>
            <h2 className={styles.headline}>
              SIE ÖFFNEN JETZT DEN FAHRZEUGKONFIGURATOR DER MAZDA MOTORS (DEUTSCHLAND) GMBH
            </h2>
          </Col>
        </Row>
        <Row>
          <Col cols={12} className={styles.content}>
            Es gelten die Datenschutzbestimmungen, die Sie unter www.mazda.de/datenschutz finden.
          </Col>
        </Row>

        <Button
          label="JETZT KONFIGURIEREN"
          href={link}
          target="_blank"
          trackingLabel="Car Configurator"
          onClick={this.closeAction}
        />
      </Modal>
    );
  }
}

export default withRouter(ConfiguratorModal);
